import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../static/styles/SelectGame.module.css';
import closeIcon from '../static/img/SelectGame/iconCloseButton.svg';
import { fetchAvailableGames, fetchGameChallenges } from '../api/games';

import pubgImage from '../static/img/DailyGamingTasks/imagePubgGaming.avif';
import apexImage from '../static/img/DailyGamingTasks/imageApexLegendsGaming.avif';
import codImage from '../static/img/DailyGamingTasks/imageCODGaming.avif';
import minecraftImage from '../static/img/DailyGamingTasks/imageMinecraftGaming.avif';
import clashOfClansImage from '../static/img/DailyGamingTasks/imageCOCGaming.avif';
import clashRoyaleImage from '../static/img/DailyGamingTasks/imageCRGaming.avif';
import fortniteImage from '../static/img/DailyGamingTasks/imageFortniteGaming.avif';
import amongUsImage from '../static/img/DailyGamingTasks/imageAmongUsGaming.avif';
import subwaySurfersImage from '../static/img/DailyGamingTasks/imageSubSurfGaming.avif';
import valorantImage from '../static/img/DailyGamingTasks/imageValorantGaming.avif';
import freeFireImage from '../static/img/DailyGamingTasks/imageFreeFireGaming.avif';
import robloxImage from '../static/img/DailyGamingTasks/imageRobloxGaming.avif';
import fifaImage from '../static/img/DailyGamingTasks/imageFifaGaming.avif';
import eightBallImage from '../static/img/DailyGamingTasks/image8BallPool.avif';

import { getActiveDayData } from '../api/auth';
import MessagePopup from '../components/MessagePopup';

const getGameImage = (gameName) => {
  switch (gameName.toLowerCase()) {
    case 'pubg mobile': return pubgImage;
    case 'apex legends': return apexImage;
    case 'call of duty': return codImage;
    case 'minecraft': return minecraftImage;
    case 'clash of clans': return clashOfClansImage;
    case 'clash royale': return clashRoyaleImage;
    case 'fortnite': return fortniteImage;
    case 'among us': return amongUsImage;
    case 'subway surfers': return subwaySurfersImage;
    case 'valorant': return valorantImage;
    case 'freefire': return freeFireImage;
    case 'roblox': return robloxImage;
    case 'fifa mobile': return fifaImage;
    case '8 ball pool': return eightBallImage;
    default: return null;
  }
};

const SelectGame = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showMessagePopup, setShowMessagePopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState();

  useEffect(() => {
    const loadGames = async () => {
      try {
        setLoading(true);
        const response = await fetchAvailableGames();
        if (response.success && response.data) {
          setGames(response.data);
        } else {
          setError('Failed to load games');
        }
      } catch (err) {
        setError('Error loading games');
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      loadGames();
    }
  }, [isOpen]);

  const handleGameSelect = async (gameId, gameName) => {
    sessionStorage.setItem('gameId', gameId);
    // console.log(`Selected game: ${gameName} with ID: ${gameId}`);
    try {
      const respose = await fetchGameChallenges(gameId);
      sessionStorage.setItem('gameId', JSON.stringify(gameId));
      if (respose.success) {
        sessionStorage.setItem('rewardClaimed', 'true');
        const activeDayData = await getActiveDayData();
        if (activeDayData) {
          sessionStorage.setItem("activeDayData", JSON.stringify(activeDayData));
          sessionStorage.setItem('activeDay', activeDayData.active_streak);
          sessionStorage.setItem('gameId', activeDayData.gameId);
          onClose();
          navigate('/tasks');
        }
      } else {
        setShowMessagePopup(true);
        setPopupMessage(respose.message)
        // return;
      }
      // onClose();
    } catch (error) {
    }
  };

  const handleClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles['game-selection-container']}>
      <div className={styles['game-selection-overlay']}>
        <div className={styles['close-button']} onClick={handleClose}>
          <img src={closeIcon} alt="Close" />
        </div>

        <div className={styles['select-game-header']}>
          <button className={styles['select-game-button']}>SELECT YOUR GAME</button>
        </div>
        <h5 style={{textAlign: 'center'}}>Select the game to complete your daily task and earn extra credits</h5>

        {loading ? (
          <div className={styles.loading}>Loading games...</div>
        ) : error ? (
          <div className={styles.error}>{error}</div>
        ) : (
          <div className={styles['games-grid']}>
            {games.map((game) => {
              const gameImage = getGameImage(game.name) || game.thumbnail;
              return (
                <div
                  key={game.gameId}
                  className={styles['game-card']}
                  onClick={() => handleGameSelect(game.gameId, game.name)}
                >
                  <div className={styles['game-card-inner']}>
                    <div className={styles['game-image-container']}>
                      <img src={gameImage} alt={game.name} className={styles['game-image']} />
                      <svg className={styles['game-border']} width="100%" height="100%" viewBox="0 0 114 147" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                        <path d="M114 145.638H0V123.521H0.638089V144.999H113.359V123.521H114V145.638Z" fill="#BD2333" />
                        <path d="M109.736 141.373H4.26129V3.94531H109.736V141.373ZM4.90254 140.741H109.097V4.58705H4.90254V140.741Z" fill="#BD2333" />
                        <path d="M113.7 94.216L109.398 96.7703V52.5786L113.7 55.1329V94.216Z" fill="#BD2333" />
                        <path d="M4.60244 62.5493V52.5786L0.300079 55.1329V94.216L4.60244 96.7703V62.5493Z" fill="#BD2333" />
                        <path d="M37.4735 4.30884L34.9211 0H79.0788L76.5265 4.30884H37.4735Z" fill="#BD2333" />
                        <path d="M70.3351 143.877H43.6617V147H70.3351V143.877Z" fill="#BD2333" />
                      </svg>
                    </div>
                    <div className={styles['game-name']}>{game.name}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {showMessagePopup && (
        <MessagePopup
          isOpen={showMessagePopup}
          onClose={onClose}
          message={popupMessage}
        />
      )}
    </div>
  );
};

export default SelectGame;